module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "news-wrapper"
    }
  }, [(!_vm.isLoading && _vm.news.length > 0) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "news-tabs"
    }
  }, _vm._l((_vm.categories), function(item) {
    return _c('li', {
      staticClass: "news-tab",
      class: {
        active: _vm.isNewsTab(item.id)
      },
      attrs: {
        "title": item.remark
      },
      on: {
        "mouseover": function($event) {
          _vm.setNewsTab(item.id), _vm.newsTab = item.id
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "30px"
    },
    attrs: {
      "id": "news"
    }
  }, [(_vm.articleLoading) ? _c('lh-loading') : _vm._l((_vm.currentNews), function(article) {
    return _c('lh-news', {
      staticClass: "news_link",
      attrs: {
        "front_img_path": article.front_img_path,
        "title": article.title,
        "summary": article.summary,
        "tags": article.tags,
        "date": article.create_time,
        "views": article.views,
        "id": article.id
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "index-more"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/ArticleHome'
      }
    }
  }, [_vm._v("查看更多")])], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h3', [_vm._v("资讯干货")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-3fb4b37c!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleList.vue
// module id = 1032
// module chunks = 40